import { max as mathMax, min as mathMin } from "./math.js";
export default function within(min, value, max) {
  return mathMax(min, mathMin(value, max));
}


//////////////////
// WEBPACK FOOTER
// ./~/@popperjs/core/lib/utils/within.js
// module id = 145
// module chunks = 1